module.exports = __webpack_public_path__ + "static/media/google_14.dd1a89cc.svg";